<script>
	import SvelteMarkdown from "svelte-markdown";

	export let onClose;
	export let text = `# Social media newsfeed
	
You'll see a social media newsfeed. For each social media card, indicate whether you would consider sharing it with your followers/friends/network.
	`;

	let exp_params = JSON.parse(localStorage.getItem("experiment_parameters"));
	let instruct_text = exp_params.filter((i) => i.parameter == "instruct")[0]
		.value;
	if (instruct_text && instruct_text.length > 0) {
		text = decodeURIComponent(instruct_text);
	}
</script>

<SvelteMarkdown source={text} />

<button on:click|preventDefault={onClose}>Continue</button>

<style>
	button {
		margin: auto;
		display: block;
		margin-bottom: 34px;
		margin-top: 34px;
	}
	@media (max-width: 500px) {
		button {
			margin: auto;
			margin-bottom: 55px;
			margin-top: 34px;
			display: block;
		}
	}
</style>
